import React from "react";

function CardLayout({
  title,
  rightContent,
  children,
  cardClass = "",
  style,
  childCardClass,
}) {
  return (
    <div id="content-page" style={style} class={`content-page ${cardClass}`}>
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class={`iq-card mb-2 ${childCardClass}`}>
              <div class="iq-card-header d-flex justify-content-between pt-2">
                <div class="iq-header-title">
                  <h4 class="card-title">{title}</h4>
                </div>

                <div class="">{rightContent}</div>
              </div>
              <div class="iq-card-body pt-2">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardLayout;
